export default __webpack_public_path__ + "static/media/streaks 50.1b9e5940.svg";